import { MIN_RECENTLY_PLAYED_GAMES } from '@/logic/main/constants';
import { LogicContext } from '@/logic/main/types';
import { mapGamesWithJackpotsV2 } from '@/logic/main/utils';

export const fetchSearchRecentlyPlayedContent = async (
  context: LogicContext
) => {
  const { user, controllersData } = context;

  const isSearchRecentlyPlayedController = (
    controllersData?.search?.components || []
  ).find(c => c[1]?.type === 'SearchRecentlyPlayed');

  const { recentlyPlayedGamesList = [], loggedIn } = user;

  if (!isSearchRecentlyPlayedController) {
    return {
      updates: [],
    };
  }

  const rpGamesWithJackpot = mapGamesWithJackpotsV2(
    recentlyPlayedGamesList,
    context.currentJackpotsV2
  );

  return {
    updates: [
      {
        type: 'setLayoutProperty',
        data: {
          path: `components.SearchRecentlyPlayed.properties`,
          value: {
            games: rpGamesWithJackpot,
            visible:
              loggedIn &&
              recentlyPlayedGamesList.length >= MIN_RECENTLY_PLAYED_GAMES,
          },
        },
      },
    ],
  };
};
